import { Directive, ElementRef, Input, OnInit, OnDestroy, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appOnboardingHint]'
})
export class OnboardingHintDirective implements OnInit, OnDestroy {
  @Input() appOnboardingHint: string = '';
  @Input() hintPosition: 'top' | 'bottom' | 'left' | 'right' = 'bottom';
  @Input() hintVisible: boolean = false;

  private tooltipElement: HTMLElement | null = null;
  private wrapperElement: HTMLElement | null = null;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    if (this.hintVisible) {
      this.show();
    }
  }

  ngOnDestroy(): void {
    this.hide();
  }

  ngOnChanges(): void {
    if (this.hintVisible) {
      this.show();
    } else {
      this.hide();
    }
  }

  private show(): void {
    if (this.tooltipElement) {
      return; // Already showing
    }

    const element = this.el.nativeElement;

    // Create wrapper for pulsating border
    this.wrapperElement = this.renderer.createElement('div');
    this.renderer.addClass(this.wrapperElement, 'onboarding-hint-wrapper');

    // Insert wrapper before element and move element into wrapper
    const parent = element.parentNode;
    this.renderer.insertBefore(parent, this.wrapperElement, element);
    this.renderer.appendChild(this.wrapperElement, element);

    // Create tooltip
    this.tooltipElement = this.renderer.createElement('div');
    this.renderer.addClass(this.tooltipElement, 'onboarding-hint-tooltip');
    this.renderer.addClass(this.tooltipElement, `hint-${this.hintPosition}`);
    this.tooltipElement.innerHTML = this.appOnboardingHint;

    // Append tooltip to wrapper
    this.renderer.appendChild(this.wrapperElement, this.tooltipElement);
  }

  private hide(): void {
    if (this.wrapperElement && this.tooltipElement) {
      const element = this.el.nativeElement;
      const parent = this.wrapperElement.parentNode;

      // Remove element from wrapper and insert back to original parent
      if (parent) {
        this.renderer.insertBefore(parent, element, this.wrapperElement);
        this.renderer.removeChild(parent, this.wrapperElement);
      }

      this.wrapperElement = null;
      this.tooltipElement = null;
    }
  }
}
